<template>
  <b-row>
    <b-col lg="4" v-for="item in items" :key="item.id">
      <b-card class="card-congratulation-medal">
        <h3>تهانينا 🎉</h3>
        <hr />
        <h5 class="mb-1">
          <span class="font-weight-bolder">اسم الشهادة :</span>
          {{ item.certificate }}
        </h5>

        <h5 class="mb-1">
          <span class="font-weight-bolder">التاريخ :</span>
          {{ item.certificate_date }}
        </h5>
        <hr />

        <b-button
          block
          v-b-modal.modal-xl
          :to="{
                name: 'CertificationsPreview',
                params: {
                  id: item.id,
                },
              }"
          variant="relief-primary"
        >
          عرض
        </b-button>
        <b-img
          :src="require('@/assets/images/illustration/badge.svg')"
          class="congratulation-medal"
        />
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import controller from "@/Controllers/StudentCertifictaeController";
import config from "../../../config/config";
import Auth from "@/Apis/Auth";

export default {
  data() {
    return {
      items: [],
      data: {},
      config: config,
    };
  },
  async created() {
    this.items = await new controller().GetAll({
      filter: "student_id|" + Auth.USER.id,
      // with: [""],
    });
    console.log(this.items);
  },
  methods: {
    view(item) {
      this.data = item.certificate;
      let text = item.certificate.meta_data
        .replace("{{full_name}}", Auth.USER.full_name)
        .replace("{{first_name}}", Auth.USER.first_name)
        .replace("{{certification_date}}", item.certificate_date)
        .replace("{{last_name}}", Auth.USER.last_name);
      //

      this.data.text = JSON.parse(text);
      console.log(this.data.text);
    },
  },
};
</script>


<style>
page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}
page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
  background-size: 21cm 29.7cm;
}
page[size="A4"][layout="horizontal"] {
  width: 29.7cm;
  height: 21cm;
  background-size: 29.7cm 21cm;
}
page[size="A3"] {
  width: 29.7cm;
  height: 42cm;
}
@media print {
  body,
  page {
    margin: 0;
    box-shadow: 0;
  }
}
</style>